import {
  DexTradeStatus,
  OpenPositionListItem,
} from 'api/types/httpsTypes/dex-trade';
import { positionStatesStatuses } from '../usePageState';

interface UpdatePayload {
  p: OpenPositionListItem;
  f: DexTradeStatus;
}

interface UpdateResult {
  updatedItems: OpenPositionListItem[];
  wasAdded: boolean;
  wasRemoved: boolean;
}

export function updatePositionsList(
  prevItems: OpenPositionListItem[],
  updatedPosition: UpdatePayload,
  isActive: boolean,
  tokenAddressFilter: string | undefined,
  botIdFilter: string | undefined
): UpdateResult {
  const updatedPos = updatedPosition.p;
  const toStatus = updatedPos.status;

  const statusRelevant =
    positionStatesStatuses[isActive ? 'active' : 'history'].includes(toStatus);

  const passesTokenFilter =
    !tokenAddressFilter || updatedPos.tokenAddress === tokenAddressFilter;

  const passesBotFilter =
    !botIdFilter ||
    updatedPos.copyTradingBotId === botIdFilter ||
    updatedPos.volatilityBotId === botIdFilter;

  const isRelevant = statusRelevant && passesTokenFilter && passesBotFilter;

  const existingIndex = prevItems.findIndex((p) => p.id === updatedPos.id);

  // ✅ CASE 1: Should be in list
  if (isRelevant) {
    if (existingIndex !== -1) {
      const updatedItems = [...prevItems];
      updatedItems[existingIndex] = {
        ...prevItems[existingIndex],
        ...updatedPos,
      };
      return { updatedItems, wasAdded: false, wasRemoved: false };
    } else {
      return {
        updatedItems: [updatedPos, ...prevItems],
        wasAdded: true,
        wasRemoved: false,
      };
    }
  }

  // ❌ CASE 2: Should be removed
  if (existingIndex !== -1) {
    return {
      updatedItems: prevItems.filter((p) => p.id !== updatedPos.id),
      wasAdded: false,
      wasRemoved: true,
    };
  }

  // ❌ CASE 3: Merged (explicit removal)
  if (isActive && toStatus === DexTradeStatus.merged && existingIndex !== -1) {
    return {
      updatedItems: prevItems.filter((p) => p.id !== updatedPos.id),
      wasAdded: false,
      wasRemoved: true,
    };
  }

  // No change
  return { updatedItems: prevItems, wasAdded: false, wasRemoved: false };
}
